import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { db } from "../api/firebase";
import { ref, get } from "firebase/database";
import GiftDetailsLayout from "../components/GiftDetailsLayout";
import "../styles/giftDetailsPremium.css";

export default function GiftDetails() {
  const { categoryId, giftId } = useParams();
  const [gift, setGift] = useState(null);
  const [loadErr, setLoadErr] = useState(null);
  const [showReplyPrompt, setShowReplyPrompt] = useState(false);

  useEffect(() => {
    if (!db) {
      setLoadErr("Card service is temporarily unavailable.");
      setGift(null);
      return;
    }

    let cancelled = false;
    setLoadErr(null);
    setGift(null);

    const load = async () => {
      try {
        const snap = await get(ref(db, `giftkart/${categoryId}/${giftId}`));
        if (cancelled) return;
        if (snap.exists()) setGift(snap.val());
        else setLoadErr("This gift link could not be found.");
      } catch (e) {
        console.error(e);
        if (!cancelled) {
          setLoadErr(
            "Could not load this card right now. Please check the link and try again."
          );
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [categoryId, giftId]);

  useEffect(() => {
    if (!gift) return undefined;
    const timer = window.setTimeout(() => {
      setShowReplyPrompt(true);
    }, 60 * 1000);
    return () => window.clearTimeout(timer);
  }, [gift]);

  if (loadErr) {
    return (
      <h2 className="loading" style={{ color: "#b91c1c", padding: "2rem" }}>
        {loadErr}
      </h2>
    );
  }

  if (!gift) return <h2 className="loading">Loading Gift...</h2>;

  return (
    <>
      <GiftDetailsLayout gift={gift} categoryId={categoryId} showEnvelope />
      {showReplyPrompt ? (
        <div className="gd-reply-pop" role="dialog" aria-modal="true" aria-label="Create reply card">
          <div className="gd-reply-pop-card">
            <h3>Create a reply e-card?</h3>
            <p>Send your own card back or make one for someone else in under a minute.</p>
            <div className="gd-reply-actions">
              <a href="/" className="gd-reply-btn gd-reply-btn--primary">
                Create e-card
              </a>
              <button
                type="button"
                className="gd-reply-btn gd-reply-btn--ghost"
                onClick={() => setShowReplyPrompt(false)}
              >
                Keep viewing
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
